/**
 * User class
 * @param {?Number} id
 * @param {?String} username
 * @param {?String} fullname
 * @param {?String} firstname
 * @param {?String} lastname
 * @param {?String} username
 * @param {?Boolean} canModifyEntries
 */
export default class User {
  constructor() {
    this.id = null;
    this.username = null;
    this.fullname = null;
    this.firstname = null;
    this.lastname = null;
    this.username = null;
    this.canModifyEntries = null;
  }

  set fullname(value) {
    this._fullname = value;
  }

  get fullname() {
    return this._fullname ? this._fullname : `${this.firstname} ${this.lastname}`;
  }
}
